import About from 'components/About';
import Contact from 'components/Contact';
import Footer from 'components/Footer';
import Hero from 'components/Hero';
import Skills from 'components/Skills';
import Works from 'components/Works';
import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

export default function LandingPage() {

    useEffect(() => {
        const startServer = async () => {
            await fetch(process.env.REACT_APP_SERVER_URL)
                .then(res => res.json())
                .then(data => console.log(data))
        }
        startServer();
    }, [])

    return (
        <>
            <Navbar></Navbar>
            <Hero></Hero>
            <About></About>
            <Skills></Skills>
            <Works></Works>
            <Contact></Contact>
            <Footer></Footer>
        </>
    );
};